// @flow

/* eslint import/prefer-default-export: 0 */

export const individualInitiativeText = (isOnV5: boolean): string => (
  isOnV5
    ? I18n.t('projects.my_projects.v5.individual_action')
    : I18n.t('projects.my_projects.individual_action')
)
